<template>
  <v-app v-if="isLoading">
    <loading />
  </v-app>
  <v-col cols="12" class="pa-3" v-else>
    <v-row>
      <v-col cols="12" md="9" class="order-md-0 order-1">
        <v-row v-if="filterdShopList.length > 0">
          <template >
            <v-col v-for="shop in shopsPages"     :key="shop.id"
              cols="12"
              lg="3"
              sm="6"
          
              :class="{ ishidden: shop.isHidden == true }"
            >
              <router-link :to="'/shop/details/' + shop.id" target="_blank" >
                <v-card class="mx-auto EK-card rounded-xl rounded-tr-0">
                  <v-img
                    height="210"
                    class="rounded-b-xl"
                    :src="
                      !shop.mainImage || !shop.mainImage.path
                        ? placeholder
                        : domainHost + shop.mainImage.path.replace('~', '')
                    "
                  ></v-img>
                  <v-card-text class="pt-3 pb-0 text-center">
                    <div class="d-flex justify-center ">
                      <div class="text-center">
                        <p class="m-0 text-dark text-center w-full">
                          {{ shop.name }}
                        </p>
                      </div>
                   
                    </div>
                    <div class="text-center">
                        <p class="m-0">{{ shop.categoriesNames[0] }}</p>
                      </div>
                    <v-divider></v-divider>
                    <v-btn
                      depressed
                      icon
                      color="orange lighten-2"
                      v-if="!checkMobileNumber(shop.mobileNumber)"
                    >
                      <v-icon class="pl-3">mdi-alert-circle</v-icon>
                    </v-btn>
                    <v-btn depressed disabled text>
                      <v-icon class="pl-3">mdi-eye</v-icon>{{ shop.visitCount }}</v-btn
                    >
                  </v-card-text>
                  <!--   new data starts here-->

                  <v-col cols="12" sm="6" md="12">
                    <v-card-text class="white rounded-xl rounded-tr-0">
                      <v-col cols="12" class="text-right text-lg-center">
                        <v-row>
                          <v-col lg="3" class="text-center">
                            <subscription-state
                              :hint="'بطاقة المعلومات'"
                              :type="shop.mainSubsState == 0 ? 1 : shop.mainSubsState"
                              :isSmall="false"
                            ></subscription-state>
                          </v-col>
                          <v-col lg="3" class="text-center">
                            <subscription-state
                              :hint="' الاشعارات'"
                              :type="shop.notiSubsState == 0 ? 1 : shop.notiSubsState"
                              :isSmall="false"
                            ></subscription-state>
                          </v-col>
                          <v-col lg="3" class="text-center">
                            <subscription-state
                              :hint="'الصور '"
                              :type="shop.imgSubsState == 0 ? 1 : shop.imgSubsState"
                              :isSmall="false"
                            ></subscription-state>
                          </v-col>
                          <v-col lg="3" class="text-center">
                            <subscription-state
                              :hint="' العروض'"
                              :type="shop.offerSubsState == 0 ? 1 : shop.offerSubsState"
                              :isSmall="false"
                            ></subscription-state>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-card-text>
                    <!-- data ends here-->
                  </v-col>
                </v-card>
              </router-link>
            </v-col>
          </template>

          <div class="text-right" style="position: fixed; bottom: 40px">
         
            <!-- <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  @click="getShopNumbers()"
                  class="mx-2"
                  fab
                  dark
                  color="IMThemeOrange"
                >
                  <v-icon small dark> mdi-file-excel-box </v-icon>
                </v-btn>
              </template>
              <span>تصدير أرقام المشتركين لملف إكسل</span>
            </v-tooltip> -->
            <v-btn small @click="isShow()" class="mx-2" fab dark color="IMThemeOrange">
              <v-icon small dark> mdi-message </v-icon>
            </v-btn>
            <v-btn
              small
              @click="isShowResult()"
              class="mx-2"
              fab
              dark
              color="IMThemeOrange"
            >
              <v-icon small dark> mdi-check-circle-outline </v-icon>
            </v-btn>
          </div>
          <v-row>
            <v-col cols="10">
              <div class="w-100 pb-10 mt-10">
                <a-pagination
             
                  v-model="shopPage"
                  @change="nextPage"
                  pageSize="8"
                  :current="shopPage"
                  :total="filterdShopList.length"
                  @showSizeChange="nextPage"
                  size="large"
                  :showTotal="(total) => `من أصل ${total} عنصر`"
                  show-quick-jumper
                />
              </div>
            </v-col>
          </v-row>
        </v-row>
        <v-row v-else class="justify-content-center mt-2">
          <h4>لا يوجد مشتركون</h4>
        </v-row>
      </v-col>
      <v-col cols="12" md="3" class="order-md-1 order-0">
        <v-card class="mx-auto EK-card rounded-xl rounded-tl-0 IMThemeGray">
          <v-card-title
            class="rounded-b-xl IMThemeOrange justify-content-center text-white"
            >الفلترة</v-card-title
          >
          <v-card-text
            class="pt-8 pb-0 justify-content-between d-flex flex-column text-center align-items-center"
          >
            <v-form v-model="valid" lazy-validation>
              <v-col cols="12">
                <v-row>
                  <v-col cols="12" sm="6" md="12" class="py-0">
                    <label for="searchName" class="text-light">بحث حسب اسم المشترك</label>
                    <v-text-field
                      id="searchNam"
                      dense
                      rounded
                      color="IMThemeGray"
                      solo
                      v-model="filterModel.searchValue"
                      append-icon="mdi-magnify"
                      @input="filterItShop()"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" class="py-0">
                    <label for="rate" class="text-light">ترتيب حسب</label>
                    <v-autocomplete
                      id="sortType"
                      dense
                      clearable
                      rounded
                      color="IMThemeGray"
                      item-color="IMThemeGray"
                      solo
                      v-model="filterModel.sortType"
                      :items="[
                        { id: 1, name: 'أبجدي تصاعدي' },
                        { id: 2, name: 'أبجدي تنازلي' },
                        { id: 3, name: 'الأقل زيارة' },
                        { id: 4, name: 'الأكثر زيارة' },
                        { id: 5, name: 'الأقل تقييم' },
                        { id: 6, name: 'الأكثر تقييم' },
                        { id: 7, name: 'تاريخ الإضافة تصاعدي' },
                        { id: 8, name: 'تاريخ الإضافة تنازلي' },
                      ]"
                      item-value="id"
                      item-text="name"
                    >
                      <template v-slot:item="data">
                        <v-list-item-content
                          v-text="data.item.name"
                        ></v-list-item-content>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" class="py-0">
                    <label for="rate" class="text-light">حسب النوع</label>
                    <v-autocomplete
                      id="rate"
                      chips
                      deletable-chips
                      dense
                      rounded
                      color="IMThemeGray"
                      item-color="IMThemeGray"
                      small-chips
                      solo
                      multiple
                      v-model="filterModel.type"
                      :items="shopTypes"
                      item-value="id"
                      item-text="name"
                    >
                      <template v-slot:item="data">
                        <v-list-item-content
                          v-text="data.item.name"
                        ></v-list-item-content>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" class="py-0">
                    <label for="area" class="text-light">حسب المنطقة</label>
                    <v-autocomplete
                      id="area"
                      chips
                      deletable-chips
                      dense
                      rounded
                      multiple
                      color="IMThemeGray"
                      item-color="IMThemeGray"
                      small-chips
                      solo
                      v-model="filterModel.area"
                      :items="areasList"
                      item-value="id"
                      item-text="name"
                    >
                      <template v-slot:item="data">
                        <v-list-item-content
                          v-text="data.item.name"
                        ></v-list-item-content>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" class="py-0">
                    <label for="store-rates" class="text-light">حسب أصناف المشترك</label>
                    <v-autocomplete
                      id="store-rates"
                      chips
                      deletable-chips
                      dense
                      rounded
                      multiple
                      color="IMThemeGray"
                      item-color="IMThemeGray"
                      small-chips
                      solo
                      v-model="filterModel.category"
                      :items="categoriesList"
                      item-value="id"
                      item-text="name"
                    >
                      <template v-slot:item="data">
                        <v-list-item-content
                          v-text="data.item.name"
                        ></v-list-item-content>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" class="py-0">
                    <label for="subscribeDate" class="text-light"
                      >حسب تاريخ نهاية اشتراك بطاقة المعلومات</label
                    >
                    <v-menu
                      ref="menu"
                      v-model="menu"
                      :close-on-content-click="false"
                      :return-value.sync="filterModel.joinDate"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-list-item
                          class="white rounded-xl"
                          v-bind="attrs"
                          v-on="on"
                          dense
                        >
                          <v-chip
                            small
                            v-for="date in filterModel.joinDate"
                            class="ml-1"
                            :key="date"
                          >
                            {{ date }}
                          </v-chip>
                          <v-btn
                            depressed
                            x-small
                            class="mr-auto"
                            @click="filterModel.joinDate = []"
                          >
                            <v-icon small>mdi-close</v-icon>
                          </v-btn>
                          <v-icon class="mr-1">mdi-calendar</v-icon>
                        </v-list-item>
                      </template>
                      <v-date-picker
                        color="IMThemeGray"
                        locale="ar-sy"
                        v-model="filterModel.joinDate"
                        range
                      >
                        <v-spacer></v-spacer>
                        <v-btn text color="IMThemeGray" @click="menu = false">
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="IMThemeGray"
                          @click="$refs.menu.save(filterModel.joinDate)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                    <small class="text-danger" v-if="isValidDateRange"
                      >الحقل يجب أن يحتوي على تاريخين - تاريخ البداية فيه أصغر من تاريخ
                      النهاية أو ان يكون الحقل فارغ</small
                    >
                  </v-col>
                  <v-col cols="12" sm="6" md="12" class="py-0">
                    <v-checkbox
                      dark
                      color="IMThemeOrange"
                      v-model="filterModel.isHidden"
                      label="المخفي فقط"
                      class="labelStyle"
                    >
                    </v-checkbox>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12">
                <v-btn
                  class="py-5 px-10 rounded-tr-0 rounded-xl"
                  :disabled="!valid || isValidDateRange"
                  @click="filterItShop()"
                >
                  تم
                </v-btn>
              </v-col>
            </v-form>
          </v-card-text>
          <v-card-text class="p-0">
            <router-link to="/shop/create" style="text-decoration: none">
              <v-btn color="IMThemeOrange" class="text-white w-100 rounded-0">
                إضافة مشترك
                <v-icon right> mdi-plus </v-icon>
              </v-btn>
            </router-link>
          </v-card-text>
          <v-card-actions class="p-3"></v-card-actions>
        </v-card>
      </v-col>
      <v-dialog v-model="show" width="1000px">
        <broadcastMessage @close="isShow()" />
      </v-dialog>
      <v-dialog v-model="showResult" width="1000px">
        <broadcastResult @close="isShowResult()" />
      </v-dialog>
    </v-row>
  </v-col>
</template>
<style lang="scss">
.v-select__selections {
  padding-top: 4px;
}
.ishidden {
  opacity: 0.5;
}
::v-deep .labelStyle label {
  margin-bottom: 0px;
}
.v-pagination__more {
  display: none !important;
}
.my-input {
  width: 120px;
}
</style>
<script>
import { mapActions, mapGetters, mapState } from "vuex";
import loading from "@/components/loading";
import broadcastMessage from "./components/broadcast-message";
import broadcastResult from "./components/broadcast-result.vue";
import Excel from "exceljs";
import { saveAs } from "file-saver";
import subscriptionState from "@/components/subscription-state.vue";
import aPagination from "ant-design-vue/lib/pagination";

export default {
  components: {
    aPagination,
    loading,
    broadcastMessage,
    broadcastResult,
    subscriptionState,
  },
  data: () => ({
    valid: true,
    menu: false,
    isValidDateRange: false,
    show: false,
    showResult: false,
    pageValue: 1,

    current: 4,
  }),
  created() {
    this.resetFilterShopsForm();
    this.fetchAreasList();
    this.fetchShops();
    this.setBreadcrumbs([
      {
        text: "المشتركون",
      },
    ]);
  },
  computed: {
    ...mapGetters([
      "shopForm",
      "filterdShopList",
      "shopsPages",
      "pageSize",
      "categoriesList",
      "shopTypes",
      "areasList",
      "isLoading",
      "placeholder",
      "domainHost",
      "filterModel",
      "shopNumbers",
      "broadcastDto",
    ]),
    ...mapState({
      formD: ({ shop }) => shop.shopForm,
    }),
    shopPage: {
      get() {
        return this.$store.getters.shopPage;
      },
      set(newValue) {
        return this.$store.dispatch("setShopPage", newValue);
      },
    },
  },
  methods: {
    ...mapActions([
      "fetchShops",
      "setShop",
      "setBreadcrumbs",
      "fetchAreasList",
      "changePage",
      "filterItShop",
      "searchStore",
      "resetFilterShopsForm",
      "broadcastMessage",
    ]),
    onShowSizeChange(current, pageSize) {
      console.log(current, pageSize);
    },
    nextPage(page) {
        console.log("nextPage",Math.ceil(this.filterdShopList.length / this.pageSize));
      this.page = page;
      this.changePage(page);
    },
    navigatePage(page) {
      if (page == "0" || page == "") {
        page = 1;
      }

      console.log(page);
      this.page = page;
      this.changePage(page);
    },
    isShow() {
      this.show = !this.show;
    },
    isShowResult() {
      this.showResult = !this.showResult;
    },
    checkMobileNumber(number) {
      const reg = /^09\d{8}$/;
      if (!number) {
        return true;
      } else if (number.indexOf("-") !== -1) {
        number = number.split("-")[0].trim();
        return reg.test(number);
      } else {
        return reg.test(number);
      }
    },
    getShopNumbers() {
      this.filterdShopList.forEach((shop) => {
        this.broadcastDto.shopIds.push(shop.id);
      });
      this.exportToExcel(this.shopNumbers);

      this.broadcastMessage(this.broadcastDto).then(() => {
      });
    },
    exportToExcel(shopNumbers) {
      const workbook = new Excel.Workbook();
      shopNumbers.unshift("Numbers");
      const worksheet = workbook.addWorksheet("Numbers");
      worksheet.columns = [{ header: "Numbers", key: "num", width: 30 }];
      worksheet.getColumn(1).values = shopNumbers;
      this.saveFile("أرقام المشتركين", workbook);
    },
    async saveFile(fileName, workbook) {
      const xls64 = await workbook.xlsx.writeBuffer({ base64: true });
      saveAs(
        new Blob([xls64], {
          type: "application/vnd.ms-excel",
        }),
        fileName
      );
    },
  },
  watch: {
    "filterModel.joinDate"(v) {
      this.isValidDateRange = !(
        v.length == 0 ||
        (!!v && v.length == 2 && new Date(v[1]) > new Date(v[0]))
      );
    },
  },
};
</script>
